import { __extends } from "tslib";
/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { avm1BroadcastEvent, hasAwayJSAdaptee, wrapAVM1NativeClass } from './AVM1Utils';
import { AVM1NativeFunction } from '../runtime';
import { AVM1ArrayNative } from '../natives';
import { AVM1Object } from '../runtime/AVM1Object';
import { AVM1PropertyDescriptor } from '../runtime/AVM1PropertyDescriptor';
function _updateAllSymbolEvents(symbolInstance) {
    if (!hasAwayJSAdaptee(symbolInstance)) {
        return;
    }
    symbolInstance.updateAllEvents();
}
var AVM1Broadcaster = /** @class */ (function (_super) {
    __extends(AVM1Broadcaster, _super);
    function AVM1Broadcaster() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AVM1Broadcaster.createAVM1Class = function (context) {
        return wrapAVM1NativeClass(context, true, AVM1Broadcaster, ['initialize'], []);
    };
    AVM1Broadcaster.initialize = function (context, obj) {
        var desc = new AVM1PropertyDescriptor(64 /* DATA */ | 1 /* DONT_ENUM */, new AVM1ArrayNative(context, []));
        obj.alSetOwnProperty('_listeners', desc);
        desc = new AVM1PropertyDescriptor(64 /* DATA */ | 1 /* DONT_ENUM */, new AVM1NativeFunction(context, function broadcastMessage(eventName) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            var listenersField = this.alGet('_listeners');
            if (!(listenersField instanceof AVM1ArrayNative)) {
                return;
            }
            avm1BroadcastEvent(context, this, eventName, args);
        }));
        obj.alSetOwnProperty('broadcastMessage', desc);
        desc = new AVM1PropertyDescriptor(64 /* DATA */ | 1 /* DONT_ENUM */, new AVM1NativeFunction(context, function addListener(listener) {
            var listenersField = this.alGet('_listeners');
            if (!(listenersField instanceof AVM1ArrayNative)) {
                return false;
            }
            var listeners = listenersField.value;
            listeners.push(listener);
            _updateAllSymbolEvents(this);
            return true;
        }));
        obj.alSetOwnProperty('addListener', desc);
        desc = new AVM1PropertyDescriptor(64 /* DATA */ | 1 /* DONT_ENUM */, new AVM1NativeFunction(context, function removeListener(listener) {
            var listenersField = this.alGet('_listeners');
            if (!(listenersField instanceof AVM1ArrayNative)) {
                return false;
            }
            var listeners = listenersField.value;
            var i = listeners.indexOf(listener);
            if (i < 0) {
                return false;
            }
            listeners.splice(i, 1);
            _updateAllSymbolEvents(this);
            return true;
        }));
        obj.alSetOwnProperty('removeListener', desc);
    };
    return AVM1Broadcaster;
}(AVM1Object));
export { AVM1Broadcaster };
